import { render, staticRenderFns } from "./DayShifts.vue?vue&type=template&id=374339de"
import script from "./DayShifts.vue?vue&type=script&lang=js"
export * from "./DayShifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports